import axios from "axios";

export const state = {
    alevelcomments: [],
};

export const getters = {
    alevelcomments: state => state.alevelcomments,
};

export const mutations = {
    setComments(state, newValue) {
        state.alevelcomments = newValue
    },
};

export const actions = {
    fetchComments({ commit }) {
        axios.get('/alevelcomments').then(res => {
            commit('setComments', res.data.alevelcomments);
        })
    },
   
};
